import React from 'react'

const Facebook = () => (
  <svg viewBox="0 0 20 40" xmlns="http://www.w3.org/2000/svg"><path d="M19.883 12.941h-6.462v-4.12c0-1.547 1.055-1.908 1.798-1.908h4.56V.11L13.5.086c-6.971 0-8.558 5.074-8.558 8.32v4.535H.909v7.01h4.032v19.835h8.48V19.95h5.723l.74-7.01z" className="fill-current" fillRule="nonzero"/></svg>
)
export default Facebook
